export default "__VITE_ASSET__C3jIpZUC__"